import { forwardRef } from "react";
import TextInput from "./TextInput";

/**
 * NumberInput — constrains input to digits and displays an optional unit
 * (e.g. "m²", "xona") as a rightSlot. Used for area, room count, etc.
 * in the Add Property form (Phase 6).
 */
const NumberInput = forwardRef(function NumberInput(
  { unit, onChange, ...rest },
  ref
) {
  const handleChange = (e) => {
    const digitsOnly = e.target.value.replace(/[^\d]/g, "");
    onChange?.({ ...e, target: { ...e.target, value: digitsOnly } });
  };

  return (
    <TextInput
      ref={ref}
      inputMode="numeric"
      onChange={handleChange}
      rightSlot={
        unit ? (
          <span className="text-body-sm text-brand-muted font-medium">{unit}</span>
        ) : null
      }
      {...rest}
    />
  );
});

export default NumberInput;
